// 为了解决换购券领取后,换账号登陆已领取状态微刷新问题
import {
  SET_LOGOUT_STATE,
} from '@/vuex/mutations-types';
const state = {
  logout: true,
};
const mutations = {
  [SET_LOGOUT_STATE](state, value) {
    state.logout = value;
  },
};
export default {
  state,
  mutations,
};
